import { useQuery } from "@tanstack/react-query"
import { useGetDefaultPaymentTool } from "./useGetDefaultPaymentTool"
import { useGetBanksList } from "./useGetBanksList"
import { IBankMeta, PaymentToolType } from "../interface"

async function merge(
  defaultPaymentToolId: string | undefined,
  banksList: IBankMeta[],
) {
  if (!defaultPaymentToolId) {
    return null
  }

  if (!banksList) {
    throw new Error("Данные отсутствуют")
  }

  const foundBank = banksList.find(
    (bank) => bank.bankId === defaultPaymentToolId,
  )

  if (!foundBank) {
    throw new Error("Банк с указанным ID не найден")
  }

  return foundBank
}

export const useGetDefaultPaymentToolBank = () => {
  const { data: defaultPaymentTool } = useGetDefaultPaymentTool(PaymentToolType.SBP_ACCOUNT)
  const { data: banksList } = useGetBanksList(null)

  const defaultPaymentToolId = defaultPaymentTool?.maskedValue

  return useQuery({
    queryKey: ["get-default-payment-tool-bank", defaultPaymentToolId],
    queryFn: () => merge(defaultPaymentToolId, banksList!.items),
    enabled: Boolean(defaultPaymentToolId && banksList),
  })
}
